import { Component, Inject, TemplateRef, ViewChild, HostListener } from '@angular/core';
import { NxModalModule } from '@aposin/ng-aquila/modal';
import {
  NX_MODAL_DATA,
  NxDialogService,
  NxModalRef,
} from "@aposin/ng-aquila/modal";
import { SharedModule } from "../../shared/shared.module";
import { NxGridModule } from '@aposin/ng-aquila/grid';

@Component({
  selector: "app-enquiry-popup",
  standalone: true,
  imports: [
    SharedModule,
    NxGridModule
  ],
  templateUrl: "./enquiry-popup.component.html",
  styleUrl: "./enquiry-popup.component.scss",
})
export class EnquiryPopupComponent {
  templateDialogRef?: NxModalRef<any>;
  popup_type: any;
  constructor(@Inject(NX_MODAL_DATA) data: any,
    private readonly dialogService: NxDialogService,
    private componentDialogRef1: NxModalRef<any>) {
    console.log("data", data.popup_type);
    this.popup_type = data.popup_type;
  }

  @ViewChild('deleteDoc') deleteDocRef!: TemplateRef<any>;
  @ViewChild('remarksAdd') remarksAddRef!: TemplateRef<any>;


  openFromTemplate4(): void {
    this.dialogService.open(this.deleteDocRef, {
      ariaLabel: 'A simple modal',
      disableClose: true,
      width: '500px',
      maxWidth: '500px'
    });
  }

  openFromTemplate1(): void {
    this.dialogService.open(this.remarksAddRef, {
      ariaLabel: 'A simple modal',
      disableClose: true,
      width: '550px',
      maxWidth: '550px'
    });
  }

  onClick() {
    this.componentDialogRef1.close('Y');
  }

  onClickRequestCancellation(action: any) {
    this.componentDialogRef1.close(action);
  }

}
